<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
  >
    <g transform="translate(0 1)">
      <g class="a" transform="translate(0 1)">
        <rect class="c" width="22" height="18" rx="3" />
        <rect class="d" x="1" y="1" width="20" height="16" rx="2" />
      </g>
      <path
        class="a"
        d="M3138.715,449h18"
        transform="translate(-3136.715 -441.5)"
      />
      <path
        class="b"
        d="M3144.542,432.438v4"
        transform="translate(-3138.542 -432.438)"
      />
      <path
        class="b"
        d="M3144.542,432.438v4"
        transform="translate(-3128.542 -432.438)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CalendarIcon',
}
</script>

<style lang="scss" scoped>
.a,
.b,
.d {
  fill: none;
}
.a,
.b {
  stroke: #2d323c;
  stroke-width: 2px;
}
.b {
  stroke-linecap: round;
}
.c {
  stroke: none;
}
</style>
